exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-uploaded-file[data-v-229c7018]{cursor:default}.dz-uploaded-file .dz-filename[data-v-229c7018]{width:calc(100% - 155px)}.dz-uploaded-file .dz-size[data-v-229c7018]{bottom:10px;left:103px}.dz-uploaded-file .dz-remove[data-v-229c7018]{bottom:8px}", ""]);

// exports
